import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { Tooltip, useTheme, Box, Typography } from "@mui/material";
import * as f from "../../utils/formatter";

const IconNotes = ({ appointment, ...props }) => {
  const theme = useTheme();

  const notes = appointment?.client?.nextAppointmentNotes ?? [];
  if (!Array.isArray(notes) || notes.length === 0) return null;

  const tooltip = (
    <Box sx={{ maxWidth: 360 }}>
      {notes.map((n, i) => {
        const author =
          n.username || n.employee?.username || f.fullName(n.employee) || "";
        return (
          <Box key={n.id ?? i} sx={{ mb: i < notes.length - 1 ? 0.5 : 0 }}>
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              {n.note}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {f.date(n.created_at)}
              {author ? ` • ${author}` : ""}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <FontAwesomeIcon
        icon={faCommentDots}
        color={theme.palette._components.message.color}
        {...props}
      />
    </Tooltip>
  );
};

export default IconNotes;
